import { BACKFILL_ADMIN_B_VOCABULARIES } from './backfill-admin-b.js';
import { BACKFILL_ADMIN_B_COPY_VOCABULARIES } from './backfill-admin-b-copy.js';
/** Slice "admin-b" of the catalog (D577): the codes the Admin console's screens M–Z had translated in their own maps. */
export const SLICE_ADMIN_B = [...BACKFILL_ADMIN_B_VOCABULARIES, ...BACKFILL_ADMIN_B_COPY_VOCABULARIES];
//# sourceMappingURL=slice-admin-b.js.map